import React from 'react';
import * as S from './styles';
import { Link } from 'react-router-dom';
// import Events from '../../Events';
import Aguas from '../../../front-novo/icons/Aguas.svg';
import Pequi from '../../../front-novo/icons/Pequi.svg';
import Tronco from '../../../front-novo/icons/Tronco.svg';
import Sol from '../../../front-novo/icons/Sol.svg';
import Gaviao from '../../../front-novo/icons/Gaviao.svg';
import bordercardimg from '../../../front-novo/home/bordercardimg.png';
function Home5() {
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <span>ERROR 404</span>
          <h1>Página não encontrada</h1>
          <p>Parece que essa página foi para o inconsciente. </p>
          <p id="second-text">
            Não conseguimos encontrar a página que você procura. Que tal voltar
            à nossa Página Inicial e tentar novamente?
          </p>
          <div>
            <Link to="/">
              <button>Voltar para a página inicial</button>
            </Link>
          </div>
        </S.TextDiv>
      </S.Section>
    </S.Main>
  );
}

export default Home5;
